export default __webpack_public_path__ + "static/media/detail_big_10_5.f88cb505.jpg";